var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.997,
    height: 15.996,
    viewBox: "0 0 15.997 15.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.084,
    y1: 0.916,
    x2: 0.916,
    y2: 0.084,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d800b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sf-instagram-outline",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M15.948,4.7a5.872,5.872,0,0,0-.372-1.941,3.92,3.92,0,0,0-.923-1.417A3.921,3.921,0,0,0,13.237.42,5.871,5.871,0,0,0,11.3.048C10.443.009,10.17,0,8,0S5.553.009,4.7.048A5.873,5.873,0,0,0,2.759.42a3.92,3.92,0,0,0-1.417.923A3.921,3.921,0,0,0,.42,2.759,5.872,5.872,0,0,0,.048,4.7C.009,5.553,0,5.826,0,8s.009,2.445.048,3.3A5.871,5.871,0,0,0,.42,13.237a3.92,3.92,0,0,0,.923,1.417,3.919,3.919,0,0,0,1.417.923,5.869,5.869,0,0,0,1.941.372C5.554,15.987,5.826,16,8,16s2.445-.009,3.3-.048a5.87,5.87,0,0,0,1.941-.372,4.089,4.089,0,0,0,2.339-2.339,5.87,5.87,0,0,0,.372-1.941C15.987,10.443,16,10.17,16,8s-.009-2.445-.048-3.3Zm-1.44,6.53a4.425,4.425,0,0,1-.275,1.485,2.649,2.649,0,0,1-1.518,1.518,4.425,4.425,0,0,1-1.485.275c-.843.039-1.1.047-3.232.047s-2.389-.008-3.232-.047a4.427,4.427,0,0,1-1.485-.275,2.479,2.479,0,0,1-.92-.6,2.478,2.478,0,0,1-.6-.92,4.425,4.425,0,0,1-.275-1.485c-.038-.843-.047-1.1-.047-3.232s.008-2.389.047-3.232a4.429,4.429,0,0,1,.275-1.485,2.48,2.48,0,0,1,.6-.92,2.476,2.476,0,0,1,.92-.6,4.424,4.424,0,0,1,1.485-.275c.843-.038,1.1-.047,3.232-.047H8c2.136,0,2.389.008,3.232.047a4.426,4.426,0,0,1,1.485.275,2.48,2.48,0,0,1,.92.6,2.476,2.476,0,0,1,.6.92,4.421,4.421,0,0,1,.275,1.485c.038.843.047,1.1.047,3.232s-.008,2.389-.047,3.232Zm0,0",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M128.646,124.539a4.107,4.107,0,1,0,4.107,4.107A4.107,4.107,0,0,0,128.646,124.539Zm0,6.773a2.666,2.666,0,1,1,2.666-2.666A2.666,2.666,0,0,1,128.646,131.312Zm0,0",
    transform: "translate(-120.648 -120.648)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M363.849,89.585a.96.96,0,1,1-.96-.96A.96.96,0,0,1,363.849,89.585Zm0,0",
    transform: "translate(-350.622 -85.857)",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.655053439602e434f004d1dbbc7b13a4.svg";
export { ForwardRef as ReactComponent };